/* FS앱 관련 스크립트 (sg-fscore) */

const prcct = $("body").data("cmpprice");

// [PRODUCT CARD 프로모션 태그 삽입] --------START---------

function getProductElements(element) {
    return [...element.querySelectorAll('.fs-results-product-card')];
}

function removeLabel(productElement) {
    const label = productElement.querySelector('.my-promo-labels2');
    label?.remove();
}
/*
function addLabel(productElement, data) {
    let badgesWrapper = productElement.querySelector(".image-wrapper .fs-badges-wrapper");
    console.log(productElement, badgesWrapper)
    if (!badgesWrapper) {
        productElement.querySelector(".image-wrapper")?.insertAdjacentHTML('beforeend', `<div class="fs-badges-wrapper"></div>`);
        badgesWrapper = productElement.querySelector(".image-wrapper .fs-badges-wrapper");
    }

    const hasSoldOutLabel = productElement.querySelector('.my-promo-labels2.sold-out');
    const hasSaleLabel = productElement.querySelector('.my-promo-labels2.sale-mega');

    const price = data?.price;
    const comparePrice = data?.comparePrice;

    if (price && comparePrice && comparePrice > price && !hasSaleLabel) {
        const save = Math.round((comparePrice - price) * 100 / comparePrice);
        if (save >= prcct) {
            badgesWrapper.insertAdjacentHTML('beforeend', `<div class="text-badge my-promo-labels2 sale-mega">${save}% OFF</div>`);
        }
    }

    if (data?.isSoldOut && !hasSoldOutLabel) {
        badgesWrapper.insertAdjacentHTML('beforeend', `<div class="text-badge my-promo-labels2 sold-out">SOLD OUT</div>`);
    }
}
*/
function getDcTextFromTags(tags) {
  if (!Array.isArray(tags)) return null;

  for (const raw of tags) {
    if (typeof raw !== "string") continue;
    const tag = raw.trim();
    if (!tag) continue;

    // ico_dc_..., ico-dc-..., dc_..., dc-... 전부 허용
    const m = tag.match(/^(?:ico[_-]?dc|dc)[_-]+(.+)$/i);
    if (m) {
      return m[1].trim();
    }
  }
  return null;
}
function fixFsIcoBadges(productElement) {
  if (!productElement) return;

  const badges = productElement.querySelectorAll(".text-badge.ico_badges");
  badges.forEach(badge => {
    const raw = (badge.textContent || "").trim();
    const m = raw.match(/^(?:ico[_-]?dc|dc)[_-]+(.+)$/i);
    if (!m || !m[1]) return;

    const clean = m[1].trim();
    badge.classList.remove("ico_badges");
    badge.classList.add("dc_tag_badge");
    badge.textContent = clean;
  });
}
function addLabel(productElement, data) {
  if (!productElement || !data) return;

  // 기존 뱃지 래퍼 우선 사용
  let badgesWrapper = productElement.querySelector(".image-wrapper .fs-badges-wrapper");
  if (!badgesWrapper) {
    const imgWrapper = productElement.querySelector(".image-wrapper");
    if (!imgWrapper) return;

    imgWrapper.insertAdjacentHTML(
      "beforeend",
      `<div class="fs-badges-wrapper fs-result-page-1hblk7n"></div>`
    );
    badgesWrapper = imgWrapper.querySelector(".fs-badges-wrapper");
  }
  if (!badgesWrapper) return;

  const hasSoldOutLabel = badgesWrapper.querySelector(".my-promo-labels2.sold-out");
  const hasSaleLabel = badgesWrapper.querySelector(".my-promo-labels2.sale-mega");

  const price = Number(data?.price);
  const comparePrice = Number(data?.comparePrice);

  const dcText = getDcTextFromTags(data?.tags);

  if (dcText && !hasSaleLabel) {
    badgesWrapper.insertAdjacentHTML(
      "beforeend",
      `<div class="text-badge my-promo-labels2 sale-mega dc_tag_badge">${dcText}</div>`
    );
  } else if (Number.isFinite(price) && Number.isFinite(comparePrice) && comparePrice > price && !hasSaleLabel) {
    const save = Math.round((comparePrice - price) * 100 / comparePrice);
    if (save >= prcct) {
      badgesWrapper.insertAdjacentHTML(
        "beforeend",
        `<div class="text-badge my-promo-labels2 sale-mega">${save}% OFF</div>`
      );
    }
  }

  if (data?.isSoldOut && !hasSoldOutLabel) {
    badgesWrapper.insertAdjacentHTML(
      "beforeend",
      `<div class="text-badge my-promo-labels2 sold-out">SOLD OUT</div>`
    );
  }
}




function removeprm(productElement) {
    const promoText = productElement.querySelector('.my-promo-text');
    promoText?.remove();
}

function addprm(productElement, data) {
    const prmcard = data?.attributes?.find(obj => obj[0] === 'My fields.promotion')?.[1]?.[0].replace(/[\u00A0\u3000]/g, " ").replace(/\s+/g, " ");
    if (prmcard) {
        productElement.querySelector(".info-container")?.insertAdjacentHTML('beforeend', `<div class="my-promo-text">${prmcard}</div>`);
    }
}

function moveBadge(productElement) {
    const shipdata = productElement.querySelector('.text-badge.fs-text-badge-fastship');
    shipdata?.parentElement.appendChild(shipdata);
}

function normalizeDcText(text) {
  if (typeof text !== "string") return text;
  const t = text.trim();
  const m = t.match(/^dc[_-]+(.+)$/i);
  return m ? m[1].trim() : t;
}

/* 제품 태그를 바탕으로 텍스트 배지를 추가하는 함수 */
function addPromoBadge(productElement, text) {
  let badgesWrapper = productElement.querySelector('.fs-badges-wrapper');

  if (!badgesWrapper) {
    productElement
      .querySelector(".image-wrapper")
      ?.insertAdjacentHTML('beforeend', `<div class="fs-badges-wrapper fs-result-page-1hblk7n"></div>`);
    badgesWrapper = productElement.querySelector('.fs-badges-wrapper');
  }

  const existingBadge = Array.from(
    badgesWrapper.querySelectorAll('.text-badge')
  ).find(badge => badge.textContent === text);

  if (!existingBadge) {
    const badge = document.createElement('div');

    if (text === 'fastship') {
      badge.className = 'text-badge fastship_badge';
      badge.textContent = '⚡FASTSHIP';
    } else if (text === 'new') {
      badge.className = 'text-badge new_badge';
      badge.textContent = text;
    } else {
      const dcText = normalizeDcText(text);
      badge.className = 'text-badge dc_tag_badge';
      badge.textContent = dcText;
    }

    badgesWrapper.appendChild(badge);
  }
}





function getProductPromos(tags) {
    return tags.reduce((promos, tag) => {
        if (tag.startsWith('ico_new')) {
            const parts = tag.split('_');
            if (parts.length > 1) {
                promos.push(parts[1]); 
            }
        } 
        else if (tag === 'fastship') {
            promos.push('fastship');
        }
        return promos; 
    }, []);
}



// function getProductPromos(tags) {
//     return tags.map(tag => {
//         if (tag.startsWith('ico_')) {
//             const parts = tag.split('_');
//             return parts.length > 1 ? parts[1] : tag;
//         }
//          return null;
//     }).filter(Boolean); 
// }

function removePromo(productElement) {
    const promoContainer = productElement.querySelector(".my-promo-tags");
    promoContainer?.remove();
}

function addPromo(productElement, value) {
    let promoContainer = productElement.querySelector(".my-promo-tags");
    if (!promoContainer) {
        productElement.querySelector(".info-container")?.insertAdjacentHTML('beforeend', `<div class="my-promo-tags"></div>`);
        promoContainer = productElement.querySelector(".my-promo-tags");
    }
    promoContainer.insertAdjacentHTML("beforeend", `<label class="promo-tags ${value.toLowerCase()}">${value}</label>`);
}

function getLocaleFromURL(url) {
    const match = url.match(/https?:\/\/[^/]+\/([^/]+)/);
    return match ? match[1] : null; // Return the locale or null if not found
}

function formatCurrency(amount, locale, currency) {
    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
        }).format(amount);
    } catch (error) {
        return 0; // Return 0 if formatting fails
    }
}

// [PRODUCT CARD 프로모션 태그 삽입] --------END---------

// [SHOW FILTER 배경 오버레이] --------START--------

function hooks() {
    function traverseShadowRoots(node, selector) {
        if (node.shadowRoot) {
            return node.shadowRoot.querySelector(selector);
        }

        for (let i = 0; i < node.childNodes.length; i++) {
            const foundElement = traverseShadowRoots(node.childNodes[i], selector);
            if (foundElement) return foundElement;
        }

        return null;
    }

    window.SerpOptions.registerHook('serp-filters', ({ element }) => {
        if (!element) return;

        element.querySelectorAll('.color-swatch-color-name').forEach(swatch => {
            if (swatch.innerHTML === "White") {
                swatch.classList.add("white");
            }
        });

        const pageParent = element.closest("#fs-serp-page");
        if (pageParent && pageParent.querySelector(".filters-container") && window.innerWidth > 480) {
            addFilterButtons(pageParent);
        }
        if(pageParent && pageParent.querySelector(".filters-container") && window.innerWidth > 480)
        {
          updateFilterButtons(pageParent);
        }
    });

    let hasProcessedTags = {}; 

    window.SerpOptions.registerHook("serp-product-grid", ({ products, element }) => {
        getProductElements(element).forEach(productElement => {
            const productID = productElement.dataset.productId;
            const data = products[productID];

            // console.log("Product Data:", data);

            removePromo(productElement);
            removeprm(productElement);
            addprm(productElement, data);



          // image resolution on mobile
            const imageCon=productElement.querySelector(".image-container");
            if(imageCon && !imageCon.classList.contains("first-img-quality-fix") && window.innerWidth<480) 
            {
              imageCon.classList.add("first-img-quality-fix");
              const img=imageCon.querySelector(".image");
              if(img) 
              {          
                if (img.getAttribute("src").includes("_657x."))
                {
                  img.setAttribute("src", img.getAttribute("src").replace("_657x.","."));
                }
                else if (img.getAttribute("src").includes("_486x."))
                {
                  img.setAttribute("src", img.getAttribute("src").replace("_486x.","."));
                }
                img.style.aspectRatio="auto";
                img.style.imageRendering="auto";
              }
            }

          

            // Select the price element
            const locale = getLocaleFromURL(window.location.href);
            const priceElement = productElement.querySelector('.price');
            
            // Extract the price value
            if (priceElement) {
                const rawPrice = priceElement.textContent.trim().replace(/[^\d.-]/g, ''); // Remove non-numeric characters
                const formattedPrice = formatCurrency(parseFloat(rawPrice), locale, Shopify.currency.active);
            
                // Update the element with the formatted price
                if (formattedPrice > 0) {
                  // Uncomment this during testing to verify currency support in our product.                  
                  // priceElement.textContent = formattedPrice;                          
                }
                
            }            
          
          
            

            moveBadge(productElement);

            // 정제된 뱃지 추가 (ico_)
            const tags = data.tags;
            if (tags) {
                if (!hasProcessedTags[productID]) {
                    const promos = getProductPromos(tags);
                    //console.log("Promos:", promos); 
                    promos.forEach(promo => {
                        addPromoBadge(productElement, promo); 
                    });
                    hasProcessedTags[productID] = true; 
                }
            }
            // if (parseFloat(data.comparePrice) > parseFloat(data.price)) {
            //     addLabel(productElement, data);
            // }
            addLabel(productElement, data);

            if (Getattributevalue(data.attributes, "My fields.isbeauty").toLowerCase() !== "true") {
                productElement.querySelector('.vendor-container')?.style?.setProperty('display', 'none');
            }

            fixFsIcoBadges(productElement);
        });

        setTimeout(copyhtmlTitle, 400);
        setTimeout(nofilterCheck, 400);
    });

  function hooksFilter() {
        function updateZIndex(setTo) {
            const announcementSection = document.querySelector('#root > [class*="shopify-section-announcement"]');
            const headerSection = document.querySelector('.shopify-section-header');
            const bodyElement = document.querySelector('body');
            const htmlElement = document.querySelector('html');

            const zIndexValue = setTo === -1 ? '-1' : '99';
            if (announcementSection) announcementSection.style.zIndex = zIndexValue;
            if (headerSection) headerSection.style.zIndex = zIndexValue;

            const overflowValue = setTo === -1 ? 'hidden' : '';
            bodyElement.style.overflowY = overflowValue;
            htmlElement.style.overflowY = overflowValue;
        }

        function handleBackgroundClick(filterModal) {
            filterModal.addEventListener('click', function (event) {
                const modalContent = filterModal.querySelector('.filters-modal');
                if (!modalContent || !modalContent.contains(event.target)) {
                    updateZIndex(99);
                }
            });
        }

        function observeModalAddition() {
            const filterModal = traverseShadowRoots(document, '.filters-modal-wrapper.fs-result-page-j6l4zq');
            if (filterModal) {
                updateZIndex(-1);
                handleBackgroundClick(filterModal);
            } else {
                const observer = new MutationObserver(function (mutationsList) {
                    mutationsList.forEach((mutation) => {
                        mutation.addedNodes.forEach(() => {
                            const filterModal = traverseShadowRoots(document, '.filters-modal-wrapper.fs-result-page-j6l4zq');
                            if (filterModal) {
                                updateZIndex(-1);
                                handleBackgroundClick(filterModal);
                                observer.disconnect();
                            }
                        });
                    });
                });
                observer.observe(document.body, { childList: true, subtree: true });
            }
        }

        function fastFilterButtonCheck() {
            const filterButton = traverseShadowRoots(document, '.filters-button-wrapper');
            if (filterButton) {
                filterButton.removeEventListener('click', handleFilterButtonClick);
                filterButton.addEventListener('click', handleFilterButtonClick);
            }
        }

        function handleFilterButtonClick() {
            observeModalAddition();
        }

        const fastCheckInterval = setInterval(fastFilterButtonCheck, 500);

        const observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach((mutation) => {
                mutation.addedNodes.forEach(() => fastFilterButtonCheck());
            });
        });
        observer.observe(document.body, { childList: true, subtree: true });

        document.addEventListener('DOMContentLoaded', fastFilterButtonCheck);
    }

    hooksFilter();
}

// [SHOW FILTER 배경 오버레이] --------END---------

// [FILTER 버튼 추가] --------START---------

function addFilterButtons(pageParent) {
    const filtersContainer = pageParent.querySelector(".filters-container");
    if (filtersContainer.querySelector(".filter-popup__bottom-buttons-fs")) return;

    const filterButtons = 
        `<div class="filter-popup__bottom-buttons-fs">
            <a class="btn btn--outline pt-btn-disabled-fs">Clear</a>
            <button class="pt-apply btn">See Items</button>
        </div>`;
    filtersContainer.insertAdjacentHTML('beforeend', filterButtons);

    const clearButton = filtersContainer.querySelector('a.pt-btn-disabled-fs');
    const applyButton = filtersContainer.querySelector('button.pt-apply');

    clearButton?.addEventListener("click", () => {
        if (!clearButton.classList.contains("pt-btn-disabled-fs")) {
            document.dispatchEvent(new CustomEvent('send-fast-simon-params', { detail: { narrow: {} } }));
        }
    });

    applyButton?.addEventListener("click", () => {
        pageParent.querySelector(".filters-modal-wrapper")?.click();
    });

    setTimeout(() => updateFilterButtons(pageParent), 200);
}

function updateFilterButtons(pageParent) {
    const numOfFilters = pageParent.querySelectorAll(".removable-tags-wrapper .removable-tag").length;
    const clearButton = pageParent.querySelector(".filter-popup__bottom-buttons-fs a");
    const applyButton = pageParent.querySelector(".filter-popup__bottom-buttons-fs button");
    const resultsText = pageParent.querySelector(".fs-total-results-text")?.innerHTML.split(" ")[0];

    if (numOfFilters === 0) {
        clearButton?.classList.add("pt-btn-disabled-fs");
    } else {
        clearButton?.classList.remove("pt-btn-disabled-fs");
    }

    if (resultsText && applyButton) {
        applyButton.innerHTML = `See ${resultsText} Results`;
    }
}

// [FILTER 버튼 추가] --------END---------

// [COLLECTION TITLE 삽입] --------START---------

function copyhtmlTitle() {
    const titleWrapper = document.querySelector(".collection-title__wrapper");
    const subcollections = document.querySelector(".collection-subcollections")?.outerHTML;
    const targetElement = document.querySelector("#fast-simon-serp-app").shadowRoot.querySelector(".top-center-container");

    if (titleWrapper && targetElement && !targetElement.querySelector('.acctitle')) {
        const htmlToPrepend = `<div class='acctitle'>${titleWrapper.innerHTML}</div>${subcollections || ''}`;
        targetElement.classList.add('sg-cltn');
        targetElement.insertAdjacentHTML("afterbegin", htmlToPrepend);
    }
}

// [COLLECTION TITLE 삽입] --------END---------

// [LINK HANDLER 가져오기] --------START---------

function activateMatchingLinks() {
    const links = document.querySelectorAll(".collection-card__location");

    const currentUrlHandler = window.location.pathname.split("/").pop();

    links.forEach(link => {
        const linkHrefHandler = link.getAttribute('href').split("/").pop();

        if (linkHrefHandler === currentUrlHandler) {
            link.classList.add("active");
        }
    });
}

document.addEventListener("DOMContentLoaded", activateMatchingLinks);

// [LINK HANDLER 가져오기] --------END---------

// [FILTER CHECK] --------START---------
function nofilterCheck() {
    const filtersWrapper = document.querySelector("#fast-simon-serp-app").shadowRoot.querySelector(".filters-grid-wrapper");
    if (filtersWrapper?.classList.contains("filters-grid-no-filters")) {
        $(".blnkbx").remove();
        $(".collection-nav-grid, .collection-sub-grid").css("grid-template-columns", "unset");
    }
}
// [FILTER CHECK] --------END---------

// Initialize hooks if available
if (window.SerpOptions) {
    hooks();
} else {
    window.addEventListener('fast-serp-ready', hooks);
}
